import _maxBy from 'lodash/maxBy'
import { I18N } from 'core-cmp/util/I18n'
import { createDateMode } from 'core-metoc/ui/multiLayer/modeDate.utils'
import { APP } from 'core-uda/model/Resource'
import { isManual } from 'core-sar/model/sarSad/sarSad-utils'

type SarSadType = any
type EditionDatumTimeEvent = {
  type: 'sarSadEditionDatumTimeChanged'
}
type EditionDatumTimeEventData = {
  action: 'update' | 'clear'
  searchDate: Date
  sarSad: SarSadType
}
type InfoPanelDataEvent = {
  type: 'infoPanelData'
}
type InfoPanelDataEventData = {
  action: 'create' | 'clear' | 'update'
  entityId: string
  data: any
}

const modeSarSadDatumDate = createDateMode({
  type: 'sarDatumTime',
  modelType: 'current',
  dateEditor: false,
  icon: 'buoy',
  label: () => I18N.msg('thm.ui.umv.ThmUmvLeftMenu.sar.title'),
})

function updateDatumChange(data: EditionDatumTimeEventData) {
  const { action, sarSad, searchDate } = data
  if (action === 'clear' || isManual(sarSad) || !searchDate) {
    modeSarSadDatumDate.setHasData(false)
    return
  }
  modeSarSadDatumDate.setHasData(true)
  modeSarSadDatumDate.setDate(searchDate)
}

export async function listenActiveSarSad() {
  await APP().whenData('sarSads')
  //const selection = APP('sarSad').selection

  APP().on(
    'infoPanelData',
    (ev: InfoPanelDataEvent, eventData: InfoPanelDataEventData) => {
      const { entityId, action, data } = eventData

      if (entityId !== 'sarSad' || action === 'create') return

      updateDatumChange({ sarSad: data, action, searchDate: data.searchDate })
    },
  )

  APP().on(
    'sarSadEditionDatumTimeChanged',
    (ev: EditionDatumTimeEvent, data: EditionDatumTimeEventData) => {
      updateDatumChange(data)
    },
  )

  /*selection.on('stateChanged', () => {
    const list: SarSadType[] = APP('sarSad').filter(
      (sarSad: SarSadType) => sarSad.isVisible() && !sarSad.isManual(),
    )
    const mostRecentSarSad = _maxBy(list, (sarSad) => sarSad.searchDate)

    if (!mostRecentSarSad?.searchDate) {
      modeSarSadDatumDate.setDate(new Date())
      return
    }
    modeSarSadDatumDate.setDate(mostRecentSarSad.searchDate)
  })*/
}

export default modeSarSadDatumDate
